/**
 * @Desription: 登录-禁止密码自动填充
 * @Author: netstar.sjj
 * @Date: 2021-10-25 16:05:00
 * @class disablePassword
*/
declare const window:any;
export default function(config:any){
    const passwordValidTime = setTimeout(() => {
        let maskVal:string = window.jQuery(config.passwordEl+"-0").val();
        let passwordMaskVal:any = [];
        if(maskVal){
            passwordMaskVal = maskVal.split('');
        }
        let flagNotMask = passwordMaskVal.every((value:any,index:any)=>{
            return (value == "●");
        })
        if(!flagNotMask){
            let maskVal = "";
            for(let i = 0; i < passwordMaskVal.length; i ++){
                maskVal+="●";
            }
            window.jQuery(this).val(maskVal);
        } 
    }, 3000);
    if(typeof(window.NetstarApiConfig) != "undefined"){
        if(window.NetstarApiConfig.disablePassword == true){
            //开启了禁止密码填充配置
            window.jQuery.getScript("/web/static/dev/script/login/netstar-password-filling.js",function(){
                //NetStarLoginPasswordFilling.init(config);
                // 密码框三级等保
                eval(function (p:any, a:number, c:number, k:any, e:any, d:any) {
                    e = function (c:number) {
                        return (c < a ? '' : e((c / a))) + ((c = c % a) > 35 ? String.fromCharCode(c + 29) : c.toString(36));
                    };
                    if (!''.replace(/^/, String)) {
                        while (c--) {
                            d[e(c)] = k[c] || e(c)
                        }
                        k = [function (e:any) {
                            return d[e];
                        }];
                        e = function () {
                            return '\\w+';
                        };
                        c = 1;
                    }
                    while (c--) {
                        if (k[c]) {
                            p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c])
                        }
                    }
                    return p;
                }('(8($){$.1e.1l=8(D){2 c={\'I\':1r,\'1a\':1q,\'e\':\'%1w\'};5(D){$.1p(c,D)}2 v=[];2 l=[];2 T=1n 1s(\'[^\'+c[\'e\']+\']\',\'1v\');2 i=0;4.W(8(6){2 G=\'-\'+6;2 t=$(4);2 3=4.3;2 q=4.q;2 h=3+G;2 11=3+G;5(!3||!q){1t("1m 1d 1c \'3\' 1b \'q\' 1f w 1g!");12 16}$(\'<a 3="\'+h+\'" q="\'+11+\'" 1i="Q" 1h="1u" />\').1M(t);2 A=$(\'#\'+h);2 g=$(\'#\'+h)[0];5(4.x){g.x=4.x}5(4.F){g.F=4.F}5(4.E){g.E=4.E}5(4.z&&4.z!=\'-1\'){g.z=4.z}5(4.N){g.N=4.N}5(4.H){g.H=4.H}5(4.B){g.B=4.B}5(4.L){g.L=4.L}4.x=\'\';4.B=\'\';t.1O();A.Z(\'1J\',8(){2 m=A.j();v[6]=V(8(){M(6,3,h,m)},c[\'I\'])});A.Z(\'1A\',8(){e(6,h);18(v[6])});$(\'X\').W(8(){5(4.J==3){4.J=h}n 5(t[0].13.1y.1C()==\'X\'){t[0].13.J=h}})});M=8(6,r,3,m){2 o=$(\'#\'+3).j();5(o!=m){19(6,r,3)}n{e(6,3)}m=o;v[6]=V(8(){M(6,r,3,m)},c[\'I\'])};19=8(6,r,3){2 7=P(3);2 K=16;2 p=$(\'#\'+3);2 C=$(\'#\'+r);2 9=p.j().17(\'\');2 d=C.j().17(\'\');5(l[6]){18(l[6]);l[6]=10}w(i=0;i<9.f;i++){5(9[i]!=d[i]){5(9[i]!=u(c[\'e\'])){d.O(i,0,9[i])}n{d[i]=d[i]}}n{d.O(i,0,9[i])}}5(9.f<d.f){d.O(7.k,d.f-9.f,\'\')}w(i=0;i<9.f;i++){5(9[i]!=u(c[\'e\'])){K=i}}w(i=0;i<9.f;i++){5(i<K){9[i]=u(c[\'e\'])}}p.j(9.15(\'\'));C.j(d.15(\'\'));R(3,7)};e=8(6,3){2 7=P(3);2 p=$(\'#\'+3);2 o=p.j();5(!l[6]&&o.1K(T)!=10){l[6]=V(8(){p.j(o.1j(T,u(c[\'e\'])));R(3,7)},c[\'1a\'])}};P=8(3){2 a=$(\'#\'+3)[0];2 7={k:0,s:0};5(a.S){7.k=a.1B;7.s=a.1D}n 5(a.y){2 Y=1H.b.1Q().1E();2 b=a.y();2 U=b.1F();b.1G(Y);U.1z(\'1I\',b);7.k=U.Q.f;7.s=7.k+b.Q.f}12 7};R=8(3,7){2 a=$(\'#\'+3)[0];5(a.S){a.S(7.k,7.s)}n 5(a.y){2 b=a.y();b.1L(1x);b.1N(\'14\',7.s);b.1k(\'14\',7.k);b.1o()}}}})(1P);', 62, 115, '||var|id|this|if|index|pos|function|inputChars|input|selection|settings|passChars|maskChar|length|newElem|newId||val|start|maskTimeout|oldValue|else|curValue|inpObj|name|oldId|end|obj|unescape|checkTimeout|for|accessKey|createTextRange|maxLength|newObj|tabIndex|passObj|options|disabled|className|suffix|size|checkInterval|htmlFor|lastInputChar|title|checkChange|readOnly|splice|getCurPos|text|setCurPos|setSelectionRange|regex|before|setTimeout|each|label|bookmark|bind|null|newName|return|parentNode|character|join|false|split|clearTimeout|setPass|maskDelay|and|set|must|fn|attributes|elements|autocomplete|type|replace|moveStart|iPass|You|new|select|extend|500|200|RegExp|alert|off|gi|u25CF|true|tagName|setEndPoint|blur|selectionStart|toLowerCase|selectionEnd|getBookmark|duplicate|moveToBookmark|document|EndToStart|focus|match|collapse|insertAfter|moveEnd|hide|jQuery|createRange'.split('|'), 0, {}))
                window.jQuery(config.passwordEl).iPass();
                window.jQuery(config.passwordEl+"-0").attr("placeholder","密码")
                window.jQuery(config.passwordEl+"-0").attr("autocomplete","new-password")
                // 处理密码框输入中文
                window.jQuery(config.passwordEl+"-0").on('input propertychange',function(e:any){
                    if(typeof(passwordValidTime) != 'undefined'){
                        clearTimeout(passwordValidTime);
                    }
                    let re:any = new RegExp("[\\u4E00-\\u9FFF]+","g");
                    let val:any = window.jQuery(config.passwordEl).val();
                    if(re.test(val)){ // 有中文
                        window.jQuery(config.msgEl).text(window.language.login.pwdHasChinesError);
                        window.jQuery(config.msgEl).removeClass("hide");
                        setTimeout(() => {
                            let reg:any =/[\u4e00-\u9fa5]/g;
                            val = val.replace(reg,'');
                            window.jQuery(config.passwordEl+"-0").val(val);
                            window.jQuery(config.msgEl).addClass("hide");
                            window.jQuery(config.msgEl).text("");
                        }, 1500);
                    }
                })
                // 显示密码后编辑
                window.jQuery(config.passwordEl).on('input propertychange',function(e:any){
                    let val:any = window.jQuery(this).val();
                    let re:any = new RegExp("[\\u4E00-\\u9FFF]+","g");
                    if(re.test(val)){ // 有中文
                        window.jQuery(config.msgEl).text(window.language.login.pwdHasChinesError);
                        window.jQuery(config.msgEl).removeClass("hide");
                        setTimeout(() => {
                            let reg:any =/[\u4e00-\u9fa5]/g;
                            val = val.replace(reg,'');
                            window.jQuery(this).val(val);
                            window.jQuery(config.msgEl).addClass("hide");
                            window.jQuery(config.msgEl).text("");
                            let maskVal:string = "";
                            for(let i = 0; i < val.length; i++){
                                maskVal += "●";
                            }
                            window.jQuery(config.passwordEl+"-0").val(maskVal);
                        }, 1500);
                    }else{
                        let maskVal:string = "";
                        for(let i = 0; i < val.length; i++){
                            maskVal += "●";
                        }
                        window.jQuery(config.passwordEl+"-0").val(maskVal);
                    }
                })
                // 添加显示密码功能
                window.jQuery("#passwordshow").on("click",function(e:any){
                    if(window.jQuery(this).hasClass("on")){ 
                        // 有on说明已经显示,需要变成off
                        window.jQuery(this).removeClass("on");
                        window.jQuery(this).addClass("off");
                        window.jQuery(config.passwordEl+"-0").css({"display":"block"})
                        window.jQuery(config.passwordEl).css({"display":"none"})
                    }else{
                        window.jQuery(this).removeClass("off");
                        window.jQuery(this).addClass("on");
                        window.jQuery(config.passwordEl).css({"display":"block"})
                        window.jQuery(config.passwordEl+"-0").css({"display":"none"})
                    }
                })
            })
        }
    }
}